import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import { OSM } from "ol/source";
import { fromLonLat, toLonLat } from "ol/proj";

// Create Context
interface MapInstance {
  layers: [any],
  view: () => void
}

const MapContext: any = createContext(null);

export const MapProvider: React.FC<{
  children: any,
  center?: [number, number] | [any, any],
  zoom?: number | any
}> = ({ children, center = [0, 0], zoom = 2 }) => {

  const mapRef = useRef<HTMLDivElement | null>(null);
  const [map, setMap] = useState<Map | null>(null);

  useEffect(() => {
    if (map) return; // Avoid re-creating the map

    const mapInstance: MapInstance | any = new Map({
      layers: [new TileLayer({ source: new OSM() })],
      view: new View({
        center: fromLonLat(center),
        zoom: zoom,
      }),
    });

    /* Add scale line control view to map */
    setMap(mapInstance);

  }, [center, map]);

  useEffect(() => {
    if (map) {
      map.getView().setCenter(fromLonLat(center));
      map.getView().setZoom(zoom);
    }
  }, [center, map, zoom]);

  return <MapContext.Provider value={{ map, mapRef }}>{children}</MapContext.Provider>;
};

// Custom Hook to use the Map Context
export const useMap: any = () => useContext(MapContext);
